import * as React from "react";
import { Card, CardContent, Typography, Grid } from "@material-ui/core";
import { TextInput, SelectArrayInput } from "react-admin";
import { CoreInfoRequestReasonType } from "../../../../Constants/Constant";

interface BasicInformationCardProps {
  record: any;
  selectedReasons: Number[];
  classes: any;
  disabled?: boolean;
}

const BasicInformationCard: React.FC<BasicInformationCardProps> = ({
  record,
  selectedReasons,
  classes,
  disabled = false,
}) => {
  return (
    <Card className={classes.card}>
      <CardContent>
        <Typography className={classes.cardTitle}>Basic Information</Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextInput
              source="refNo"
              label="REFERENCE NUMBER"
              fullWidth
              variant="outlined"
              defaultValue={record.refNo}
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            {selectedReasons.length > 0 && (
              <SelectArrayInput
                source="coreInfoRequestReasons"
                choices={CoreInfoRequestReasonType}
                optionText="reasonType"
                optionValue="value"
                variant="outlined"
                disabled={disabled}
                fullWidth
              />
            )}
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextInput
              source="customer"
              label="CUSTOMER"
              fullWidth
              variant="outlined"
              disabled
              defaultValue={record.customer}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextInput
              source="customerPo"
              label="CUSTOMER PO"
              fullWidth
              variant="outlined"
              disabled
              defaultValue={record.customerPo}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextInput source="pn" label="PN" fullWidth variant="outlined" disabled defaultValue={record.pn} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextInput source="sn" label="SN" variant="outlined" fullWidth disabled defaultValue={record.sn} />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default BasicInformationCard;
